import { API_BASE_URL } from "@/config";
import { validate_country_code } from "@/utils/validations";
import countries from "i18n-iso-countries";
import { useToast } from '@/components/Toast/useToast';

export default {
    name: 'AmlForm',
    setup() {
        const { showSuccess, showError } = useToast();
        
        return {
            showSuccess,
            showError
        };
    },
    data() {
        return {
            form: {
                first_name: '',
                last_name: '',
                date_of_birth: '',
                gender: '',
                country_code: 'ZAF' // Default to SA
            },
            countries: {}
        };
    },
    emits: ['service_status_complete'],
    methods: {
        handle_submit() {
            if (!this.form.first_name || !this.form.last_name || !this.form.date_of_birth || !this.form.gender || !this.form.country_code) {
                this.showError('Error', 'All fields are required.');
                return;
            }
            const date_regex = /^\d{4}-\d{2}-\d{2}$/;
            if (!date_regex.test(this.form.date_of_birth)) {
                this.showError('Error', 'Invalid date format. Please use YYYY-MM-DD.');
                return;
            }

            const string_fields = ['first_name', 'last_name', 'gender', 'country_code'];
            for (const field of string_fields) {
                if (typeof this.form[field] !== 'string' || !this.form[field].trim()) {
                    this.showError('Error', `Invalid input for ${field.replace('_', ' ')}. Please enter a valid string.`);
                    return;
                }
            }

            if (!validate_country_code(this.form.country_code)) {
                this.showError('Error', 'Invalid country code. Please enter valid country code (e.g., ZAF).');
                return;
            }

            const TOKEN = localStorage.getItem('token');
            const ANTI_MONEY_LAUNDERING_API = `${API_BASE_URL}/verify_api/instant_verify_api/anti_money_laundering/`;

            this.error = '';

            var date_yyyymmdd = this.form.date_of_birth.replace(/-/g, '');

            $.ajax({
                url: ANTI_MONEY_LAUNDERING_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    first_name: this.form.first_name,
                    last_name: this.form.last_name,
                    date_of_birth: date_yyyymmdd,
                    gender: this.form.gender,
                    country_code: this.form.country_code
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });
                },
                success: () => {
                    Swal.close();
                    this.showSuccess('Successful', 'AML Check ran successfully', 3000);
                    this.$emit('service_status_complete');
                    this.form.first_name = '';
                    this.form.last_name = '';
                    this.form.date_of_birth = '';
                    this.form.gender = '';
                    this.form.country_code = '';
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'Something went wrong!';

                    if (error.responseJSON && error.responseJSON.message) {
                        error_message = error.responseJSON.message;
                    }

                    this.showError('Error', error_message);
                }
            });
        },
    },
    created() {
    countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
    const countryList = countries.getNames("en");
    const countryListWithIso3 = Object.entries(countryList).map(([iso2, name]) => ({
        name,
        iso3: countries.alpha2ToAlpha3(iso2),
    }));
    this.countries = countryListWithIso3;
    }
};
